import { autoinject, transient } from "aurelia-dependency-injection";
import { DateExpressionParser } from "../helpers/date-expressions.helper";
import { DataType, QueryLookupsWithContext } from "../models/queries.models";
import { UserClientService } from "../services/basic/user-client.service";
import { LookupClientService } from "../services/lookups/lookup-client.service";


@autoinject
@transient()
export class InitFilterValueConverter {

    constructor(public userClientService: UserClientService,
        public lookupClientService: LookupClientService) { }

    toView(value: any, options: { type: number, contextPropertyValue: any, lookup: string, tags: string }) {
        return this.convert(value, options);
    }

    fromView(value, options: { type: number, contextPropertyValue: any, lookup: string, tags: string }) {
        return this.convert(value, options);
    }

    convert(value: any, options: { type: number, contextPropertyValue: any, lookup: string, tags: string }) {

        let result: any = value;
        const format: DataType = options.type || 0;

        switch (format) {
            case DataType.Number:
            case DataType.Double:
            case DataType.EntityFinder:
                {
                    if (value && ["-", "+"].indexOf(value.toString().trim()) > -1) {
                        return value;
                    }
    
                    if (!value) {
                        return value === 0 ? 0 : null;
                    }
                    const regexObject: RegExp = new RegExp("[-+]?[0-9]*\\.?[0-9]+");
    
                    //check the type is a number and the value is comma separated of integers
                    if (format == DataType.Number && typeof value == "string" && value.split(",").every(x => !x || Number.parseInt(x))) {
                        result = value;
                    }
                    //check if value is not an array and its truly a number
                    else if (value != null && !Array.isArray(value) && regexObject.test(value.toString())) {
                        return value != "" ? Number(value) : null;
                    }
                    else if (typeof value !== "number" && Array.isArray(value)) {
                        result = value;
                    }
                    else {
                        return 0;
                    }
                    break;
                }
            case DataType.Boolean:
                if (value != null && typeof value !== "boolean") {
                    result = false;
                }
                break;
            case DataType.Date:
            case DataType.DateTime:
                if (value === null) {
                    return value;
                }
                if (value && DateExpressionParser.isValidExpression(value)) {
                    result = value;
                } else if (typeof value !== "object" || !(value instanceof (Date))) {
                    //fix app freezing because in date picker date keeps changing to current date and time
                    const date = new Date().setSeconds(0, 0);
                    result = typeof value === "string" ? new Date(value) : new Date(date);
                }
                break;
            case DataType.Lookup:
            case DataType.HierarchicalLookup:
                {
                    const currentUser = this.userClientService.currentUser;
                    const contextProperty = QueryLookupsWithContext.filter(x => x.lookup.toLowerCase() == (options.lookup || '').toLowerCase())[0];
                    if (contextProperty && options.contextPropertyValue && value == options.contextPropertyValue) {
                        result = currentUser[contextProperty.contextProperty];
                    }
                    break;
                }
            case DataType.Default:
                result = value ? value.toString() : value;
                break;
            default:
                if (typeof value !== "string" && value) {
                    result = undefined;
                }
                break;
        }

        return result;
    }
}
